export default __webpack_public_path__ + "static/media/chat-icon-bottom-nav-mobile-active.57014b64.webp";